import React from 'react'
import video4 from '../photo_video/4.mp4'
import video5 from '../photo_video/5.mp4'
import res1 from '../photo_video/21.jpg'
import res2 from '../photo_video/2.jpg'
import res3 from '../photo_video/3.jpg'
import res6 from '../photo_video/6.jpg'
import res7 from '../photo_video/7.jpg'
import res8 from '../photo_video/8.jpg'
import res10 from '../photo_video/10.jpg'
import res12 from '../photo_video/12.jpg'
import res13 from '../photo_video/13.jpg'
import res14 from '../photo_video/14.jpg'
import res15 from '../photo_video/15.jpg'
import res16 from '../photo_video/16.jpg'
import res17 from '../photo_video/17.jpg'
import res19 from '../photo_video/19.jpg'
import res20 from '../photo_video/20.jpg'

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

function Photos() {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div className='container' >
            <div className='mt-5' id='Result'>
                <div>
                    <div className='d-flex justify-content-center mt-3'>
                        <div className='mb-5 position-relative'><h2 className='pageHeader'>Result Sharing</h2></div>
                    </div>
                    <p className='borderLeft'>
                        Introducing Amazing Transformation - the key to unlocking a healthier you! With our range of delicious, nutritious foods, you can experience incredible health results like never before.Don't settle for ordinary when you can experience something truly extraordinary. Join the Amezing Transformation movement and take charge of your health today!</p>
                </div>
                <div className='Boxes'>
                    {/* <video muted controls autoPlay loop style={{ height: '500px', width: '300px', marginTop: '50px' }}>
                        <source src={video1} type="video/mp4" />
                    </video>
                    <video muted controls autoPlay loop style={{ height: '500px', width: '300px', marginTop: '50px' }}>
                        <source src={video3} type="video/mp4" />
                    </video> */}
                    <div style={{ width: '100%' }} className='d-flex justify-content-evenly flex-wrap'>
                        <video muted controls autoPlay className='resVideo' loop>
                            <source src={video4} type="video/mp4" />
                        </video>
                        <video muted controls autoPlay className='resVideo' loop>
                            <source src={video5} type="video/mp4" />
                        </video>
                    </div>
                    {/* <div className='resVideo' >
                        <iframe src={video5} style={{ height: '100%', width: '100%' }} allow="autoplay"></iframe>
                    </div> */}
                    <div className='w-100 text-end mt-4'>
                        <h3 className='color-red'>For more results contact us . . .</h3>
                    </div>
                </div>
            </div>
            <div className='latestPics mt-5' id='photos'>

                <div className='row cardLatest'>
                    <div className='row mb-4'>
                        <div>
                            <div className='container d-flex flex-column justify-content-center h-100 mt-3'>
                                <h2 align='center'>New <span className='color-red'>Transformation</span></h2>
                                <div className='mt-5'>
                                    <p className='borderLeft'>Discover the true potential of your body with Amezing Transformation. Our carefully curated selection of wholesome, natural ingredients will nourish your body from within, helping you achieve your health goals and transform your life.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Carousel responsive={responsive} showDots={true} autoPlaySpeed={1500} infinite autoPlay className='mt-3'>
                        {[res2,res6, res7, res8,  res10].map((item) => {
                            return <div>
                                <div className="portfolio text-center ">
                                    <div className="thumbnail">
                                        <img className='res5' src={item} alt="" />
                                    </div>
                                </div>
                            </div>
                        })}
                    </Carousel>
                    <Carousel responsive={responsive} showDots={true} autoPlaySpeed={1500} infinite autoPlay className='mt-3'>
                        {[ res1,res12, res13, res14, res15].map((item) => {
                            return <div>
                                <div className="portfolio text-center ">
                                    <div className="thumbnail">
                                        <img className='res5' src={item} alt="" />
                                    </div>
                                </div>
                            </div>
                        })}
                    </Carousel>
                    <Carousel responsive={responsive} showDots={true} autoPlaySpeed={1500} infinite autoPlay className='mt-3'>
                        {[res3,res16, res17, res19, res20].map((item) => {
                            return <div>
                                <div className="portfolio text-center ">
                                    <div className="thumbnail">
                                        <img className='res5' src={item} alt="" />
                                    </div>
                                </div>
                            </div>
                        })}
                    </Carousel>
                   
                </div>
            </div>
        </div>
    )
}

export default Photos
